import { API } from "aws-amplify";

export interface IUploadFileParams {
  path: string;
  name: string;
  size: number;
  type: string;
  category_id: string;
  customer_id: string;
  item_id: string;
  task_id?: string;
  task_group_id?: string | null;
  is_required_file_upload_folder?: boolean;
}

export interface IUploadSignedUrlResponse {
  item_id: string;
  url: string;
  file: {
    id: string;
    key: string;
    name: string;
    s3_name: string;
    size: number;
  };
}

export const getUploadSignedUrl = (
  portalId: string,
  body: IUploadFileParams[]
) =>
  API.post("SECURED_API", `/portal/${portalId}/files/getUploadSignedUrl`, {
    body,
  });
